import { useEffect, useState } from 'react';
import {
  PossibleCompetitorDocument,
  listPossibleCompetitorDocuments,
  peekPossibleCompetitorDocuments,
} from 'services/actions/ai_management_possible_competitors';

export function usePossibleCompetitorDocuments(
  biddingId: number | null,
  historicBiddingId: number,
  cnpj: string,
) {
  const peek = () =>
    biddingId ? peekPossibleCompetitorDocuments(biddingId, historicBiddingId, cnpj) : undefined;
  const [documents, setDocuments] = useState<PossibleCompetitorDocument[]>(
    () => peek()?.data.documentos ?? [],
  );
  const [loading, setLoading] = useState(() => !peek());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!biddingId) {
      setLoading(false);
      setError(true);
      return undefined;
    }

    const hit = peek();
    if (hit) {
      setDocuments(hit.data.documentos ?? []);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError(false);

    listPossibleCompetitorDocuments(biddingId, historicBiddingId, cnpj)
      .then(({ data }) => {
        if (!active) return;
        setDocuments(data.documentos ?? []);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [biddingId, historicBiddingId, cnpj]);

  return { documents, loading, error };
}
